export default __webpack_public_path__ + "static/media/0.aa5da77e.svg";